export class DeclaracaoSaudeViewModel {
  id!: string | null;
  proposalId!: string;
  holderProposalId!: string;
  dependentProposalId!: string;
  weight!: number | null;
  height!: number | null;
  imc!: number | null;
  optionForPreExistingIllnesses!: number;
  codeQuestion!: number;
  response!: boolean;
  eventDate1!: number;
  descriptionEvent1!: string;
  eventDate2!: number;
  descriptionEvent2!: string;
  eventDate3!: number;
  descriptionEvent3!: string;
  eventDate4!: number;
  descriptionEvent4!: string;
}
